import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { CSSGenerateLayer } from './cssGenerate.js';

const VARIANT_COLOR_HEX = {
    default: COLOR_PALETTE.slateGrey100,
    "default-inverse": COLOR_PALETTE.slateGrey80,
    danger: COLOR_PALETTE.white,
    "danger-inverse": COLOR_PALETTE.red100,
    primary: COLOR_PALETTE.white,
    context: COLOR_PALETTE.white,
    "context-secondary": "context",
    "context-inverse": "context",
    disabled: COLOR_PALETTE.white,
    "disabled-inverse": COLOR_PALETTE.slateGrey20,
    warning: COLOR_PALETTE.white,
    "warning-inverse": COLOR_PALETTE.yellow100,
    "on-light": COLOR_PALETTE.slateGreyDark50
};
const VARIANT_BG_COLOR_HEX = {
    default: COLOR_PALETTE.slateGrey10,
    "default-inverse": COLOR_PALETTE.transparent,
    danger: COLOR_PALETTE.red100,
    "danger-inverse": COLOR_PALETTE.white,
    primary: COLOR_PALETTE.blue100,
    context: "context",
    "context-secondary": "context10",
    "context-inverse": COLOR_PALETTE.transparent,
    disabled: COLOR_PALETTE.slateGrey20,
    "disabled-inverse": COLOR_PALETTE.transparent,
    warning: COLOR_PALETTE.yellow100,
    "warning-inverse": COLOR_PALETTE.white,
    "on-light": COLOR_PALETTE.white
};
const VARIANT_BG_COLOR_HOVER_HEX = {
    default: COLOR_PALETTE.slateGrey20,
    "default-inverse": "context10",
    danger: COLOR_PALETTE.redDark10,
    "danger-inverse": COLOR_PALETTE.slateGrey5,
    primary: COLOR_PALETTE.blueDark10,
    context: "contextDark10",
    "context-secondary": "context30",
    "context-inverse": "context10",
    disabled: COLOR_PALETTE.slateGrey40,
    "disabled-inverse": COLOR_PALETTE.transparent,
    warning: COLOR_PALETTE.yellowDark10,
    "warning-inverse": COLOR_PALETTE.slateGrey5,
    "on-light": "context10"
};
const isThemeContextColor = (color)=>{
    return color.startsWith("context");
};
const getColor = (color, theme)=>{
    if (isThemeContextColor(color)) {
        return theme?.COLORS[color];
    }
    return COLOR_PALETTE[color];
};
const parseThemeVariantColorMap = (colorMap)=>(props)=>{
        if (!props.variant) {
            return "";
        }
        const currentColor = colorMap[props.variant];
        if (!isThemeContextColor(currentColor)) {
            return colorMap[props.variant];
        }
        return props.theme.COLORS[currentColor];
    };
const getThemeVariantContentColor = parseThemeVariantColorMap(VARIANT_COLOR_HEX);
const getThemeVariantBGColor = parseThemeVariantColorMap(VARIANT_BG_COLOR_HEX);
const getThemeVariantBGHoverColor = parseThemeVariantColorMap(VARIANT_BG_COLOR_HOVER_HEX);
const getThemeVariantColor = (themeColor)=>(props)=>{
        return props?.theme?.COLORS[themeColor];
    };
/**
 * Helper function for determining inverse variants.
 * Needed for some styles that apply differently when either inverse or 'normal' - e.g. global disabled stylings
 */ const isInverseVariant = (variant)=>{
    return variant.includes("-inverse");
};
/**
 * Set the current z-index layer
 * (needed so that nested portals can be handled - e.g. select popovers within modals, or *gasp* modals within modals)
 */ const setPortalLayer = (zIndex = 1)=>(themeProps)=>{
        return CSSGenerateLayer(themeProps?.theme?.PORTAL_LAYER ? themeProps?.theme?.PORTAL_LAYER + zIndex : zIndex);
    };

export { getColor, getThemeVariantBGColor, getThemeVariantBGHoverColor, getThemeVariantColor, getThemeVariantContentColor, isInverseVariant, isThemeContextColor, setPortalLayer };
